import { render, staticRenderFns } from "./insuranceH5.vue?vue&type=template&id=94e8d3fc&scoped=true&"
import script from "./insuranceH5.vue?vue&type=script&lang=js&"
export * from "./insuranceH5.vue?vue&type=script&lang=js&"
import style0 from "./insuranceH5.vue?vue&type=style&index=0&id=94e8d3fc&prod&scoped=true&lang=css&"
import style1 from "./insuranceH5.vue?vue&type=style&index=1&id=94e8d3fc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94e8d3fc",
  null
  
)

export default component.exports